// extracted by mini-css-extract-plugin
module.exports = {"ldsGrid":"style-module--lds-grid--1ejPy"};